
import React from "react";
import DonutChart from "./DonutChart";
import BaseLineChart from "./BaseLineChart";

/**
 * DonutChartWrapper
 * A simple, reusable wrapper for a Doughnut chart (or any chart) with:
 * - title + subtitle
 * - optional right-side header controls (buttons, toggles, etc.)
 * - stable chart area height
 *
 * Usage:
 * <DonutChartWrapper title="Occupancy" subtitle="Last 15 min" right={<MyToggle />}>
 *   <Doughnut data={...} options={...} />
 * </DonutChartWrapper>
 */

function walkTree(all_data, node, group_type, data_type, source_data, filters) {

    if (node.visible) {
        if (node.expand && node.children) {
            for (var key in node.children) {
                walkTree(all_data, node.children[key], key, data_type, source_data, filters);
            }

        }
        else {
            var row = {
                ...filters[node.level].groups[group_type],
                data: { ...source_data[node.level][data_type][group_type] }
            }
            all_data.push(row)
        }

    }

    return all_data;
}

export function makeLineDatasetStyle({
    color,
    stacked = false,     // affects fill behaviour only

    tension = 0.2,
    borderWidth = 2,
    showPoints = false,
} = {}) {
    let fill = stacked;
    const fillColor = fill
        ? `color-mix(in srgb, ${color} 100%, transparent)`
        : undefined;

    return {
        borderColor: color,
        backgroundColor: fillColor,
        borderWidth,
        tension,
        fill: fill ? "origin" : false,
        // points
        pointRadius: showPoints ? 2 : 0,
        pointHoverRadius: 3,
        pointHitRadius: 10,

        // nicer lines
        borderCapStyle: "round",
        borderJoinStyle: "round",
        spanGaps: true,
    };
}

function pairDataAndMetadata(data, filters, group_type, data_type, value_type, stacked) {


    var data = walkTree([], group_type.all, "all", data_type, data, filters)


    if (value_type == 'both') {
        var out = [];

        for (var dataset of data) {
            out.push({
                ...dataset,
                ...makeLineDatasetStyle({ color: dataset.colour, stacked }),

                data: Object.entries(dataset.data).map(function ([timestamp, row]) {

                    var ret = {
                        x: timestamp * 1000,
                        y: row.in
                    }

                    return ret;
                })
            },
                {
                    ...dataset,
                    ...makeLineDatasetStyle({ color: dataset.colour, stacked }),

                    data: Object.entries(dataset.data).map(function ([timestamp, row]) {

                        var ret = {
                            x: timestamp * 1000,
                            y: row.out * -1
                        }

                        return ret;
                    })
                })
        }


        return out;
    }
    else if (value_type == 'both_rate_minute') {

        var out = [];

        for (var dataset of data) {
            out.push({
                ...dataset,
                ...makeLineDatasetStyle({ color: dataset.colour, stacked }),

                data: Object.entries(dataset.data).map(function ([timestamp, row]) {

                    var ret = {
                        x: timestamp * 1000,
                        y: row.in_rate_minute
                    }

                    return ret;
                })
            },
                {
                    ...dataset,
                    ...makeLineDatasetStyle({ color: dataset.colour, stacked }),

                    data: Object.entries(dataset.data).map(function ([timestamp, row]) {

                        var ret = {
                            x: timestamp * 1000,
                            y: row.out_rate_minute * -1
                        }

                        return ret;
                    })
                })
        }


        return out;

    }


    return data.map(function (dataset) {


        return {
            ...dataset,
            ...makeLineDatasetStyle({ color: dataset.colour, stacked }),

            data: Object.entries(dataset.data).map(function ([timestamp, row]) {

                var ret = {
                    x: timestamp * 1000,
                }
                switch (value_type) {
                    case 'in': ret.y = row.in; break;
                    case 'out': ret.y = row.out * -1; break;
                    case 'net': ret.y = row.in - row.out; break;
                    case 'net_rate_minute': ret.y = row.net_rate_minute; break;
                    case 'in_rate_minute': ret.y = row.in_rate_minute; break;
                    case 'out_rate_minute': ret.y = row.out_rate_minute * -1; break;
                }
                return ret;
            })
        }
    })

}

export function LineChartWrapper({
    data, filters, group_type, data_type, value, stacked, ...props
}) {

    let datasets = pairDataAndMetadata(data, filters, group_type, data_type, value, stacked);
    // return "";

    return (
        <BaseLineChart  {...{ ...props, datasets, stacked }} />
    );
}
